import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Session management service.
 * Manages the current authenticated user's session.
 *
 * Since auth is handled by the parent medical app,
 * this service accepts a userId and validates it exists in the database.
 */
@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private currentUserIdSubject = new BehaviorSubject<string | null>(null);
  public currentUserId$ = this.currentUserIdSubject.asObservable();

  private sessionValidSubject = new BehaviorSubject<boolean>(false);
  public sessionValid$ = this.sessionValidSubject.asObservable();

  constructor() {}

  /**
   * Initialize session with a user ID from the parent app.
   * Called when the chat widget is mounted with an authenticated user.
   *
   * @param userId The authenticated user's ID from your user table
   */
  public initializeSession(userId: string): void {
    if (!userId || userId.trim() === '') {
      throw new Error('Invalid userId for session initialization');
    }
    this.currentUserIdSubject.next(userId);
    this.sessionValidSubject.next(true);
    console.log(`Chat session initialized for user: ${userId}`);
  }

  /**
   * End the current session (when user logs out or widget closes).
   */
  public endSession(): void {
    this.currentUserIdSubject.next(null);
    this.sessionValidSubject.next(false);
    console.log('Chat session ended');
  }

  /**
   * Get the current user ID synchronously.
   */
  public getCurrentUserId(): string | null {
    return this.currentUserIdSubject.value;
  }

  /**
   * Check if session is valid.
   */
  public isSessionValid(): boolean {
    return this.sessionValidSubject.value;
  }
}
